import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const clearOldBrowserCaches = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => {
        registrations.forEach(registration => registration.unregister());
      })
      .catch(() => {});
  }

  if ('caches' in window) {
    window.caches
      .keys()
      .then(cacheNames => Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName))))
      .catch(() => {});
  }
};

clearOldBrowserCaches();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
